export default function EditCardBg() {
  return (
    <svg
      className="brand-logo-bg"
      width="105"
      height="128"
      viewBox="0 0 105 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M39.956 116.821L15.4013 92.2712C6.29993 96.6192 0 105.889 0 116.658C0 131.585 12.0982 143.691 27.0174 143.691C37.78 143.691 47.0443 137.387 51.3897 128.274L39.956 116.827V116.821Z"
        fill="#6AC200"
      />
      <path
        d="M68.9345 76.5809C63.1948 70.8379 63.1948 61.4902 68.9345 55.7472L80.935 43.7398L56.7385 19.5425C55.0707 17.8998 52.9078 17.0133 50.7383 16.896C48.2626 16.7851 45.7935 17.6717 43.9302 19.536L15.7271 47.7619L3.72009 59.7432C0.189005 63.3024 0.189005 69.0323 3.72009 72.5915L43.9563 112.825L72.1333 141.044C75.6905 144.577 81.4171 144.577 84.9742 141.044L109.158 116.827L68.9345 76.5809Z"
        fill="#6AC200"
      />
      <path
        d="M194.353 87.9884L125.94 19.5424C122.403 16.0028 116.656 16.0028 113.119 19.5424L84.9287 47.7487L125.145 87.9884C128.683 91.5281 128.683 97.2775 125.145 100.817L113.151 112.818L141.341 141.024C144.879 144.564 150.625 144.564 154.163 141.024L194.347 100.817C197.884 97.2775 197.884 91.5281 194.347 87.9884H194.353Z"
        fill="#6AC200"
      />
      <path
        d="M125.145 87.9885L84.9284 47.7488L72.9345 59.7497C69.3968 63.2893 69.3968 69.0388 72.9345 72.5784L113.151 112.818L125.145 100.817C128.683 97.2776 128.683 91.5282 125.145 87.9885Z"
        fill="#6AC200"
      />
    </svg>
  );
}
